import React from 'react';
import { FieldRow } from 'components/Form/subcomponents/FieldRow';
import { ButtonsRow, CleanFilter, ModalContent, SaveButton, StyledModal } from './styled';
import { MultiSelectDropdown } from 'newComponents/Form/Multiselect';
import { FormGroup } from 'components/Form/subcomponents/FormGroup';
import { ReactComponent as XIcon } from 'assets/icons/ui-elements/small/x-mark-sm.svg';
import { ReactComponent as ScrewDrive } from 'assets/icons/ui-elements/small/screwdriver_wrench_sm.svg';
import { ReactComponent as User } from 'assets/icons/ui-elements/small/user-sm.svg';

interface FilterOption {
  label: string;
  value: string;
  foto?: string;
}

interface FilterExecutorModalProps {
  title: string;
  setClose: (open: boolean) => void;
  executoresFields: FilterOption[];
  setoresFields: FilterOption[];
  executoresValues: string[];
  setoresValues: string[];
  onExecutoresChange: (values: unknown) => void;
  onSetoresChange: (values: unknown) => void;
  onFilter: () => void;
  onClearFilters: () => void;
  onExecutoresSearch?: (term: string) => void;
}

export const FilterExecutorModal: React.FC<FilterExecutorModalProps> = ({
  title,
  setClose,
  executoresFields,
  setoresFields,
  executoresValues,
  setoresValues,
  onExecutoresChange,
  onSetoresChange,
  onFilter,
  onClearFilters,
  onExecutoresSearch,
}) => {
  return (
    <StyledModal title={title} setClose={setClose}>
      <ModalContent>
        <FieldRow marginBottom="20px" />
        <FormGroup label="Setores">
          <MultiSelectDropdown
            options={setoresFields}
            value={setoresValues}
            onChange={onSetoresChange}
            size="md"
            width="416px"
            placeholder="Selecione"
            iconLeft={[<ScrewDrive key="screwdrive-icon" />] as React.ReactNode}
            clearable={true}
            top="27px"
            searchable={true}
            temSelecionarTodos={true}
            showScrollbar={true}
          />
        </FormGroup>
        <FieldRow marginBottom={'20px'} />

        <FormGroup label="Executores">
          <MultiSelectDropdown
            options={executoresFields}
            value={executoresValues}
            size="md"
            width="416px"
            hasFoto={true}
            onChange={onExecutoresChange}
            placeholder="Buscar executores"
            iconLeft={[<User key="user-icon" />] as React.ReactNode}
            clearable={true}
            top="27px"
            searchable={true}
            searchMode="remote"
            onSearch={onExecutoresSearch}
            temSelecionarTodos={false}
            showScrollbar={true}
          />
        </FormGroup>
        <FieldRow marginBottom="20px" />
        <ButtonsRow>
          <SaveButton onClick={onFilter}>Filtrar</SaveButton>
          <CleanFilter onClick={onClearFilters} title="Limpar filtros de Executores e Setores">
            <XIcon />
            Limpar filtros
          </CleanFilter>
        </ButtonsRow>
      </ModalContent>
    </StyledModal>
  );
};
